import * as React from 'react';
import Slider, { Settings } from 'react-slick';

import { Zoom } from '../Zoom';

import './index.scss';

const carouselConfig: Settings = {
    customPaging: () =>  <div className="dot" />,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    dotsClass: 'slick-dots slick-thumb'
};

interface IProps {
    content: string[];
    setSelectedSrc: (src: string) => void;
}

export const Carousel: React.FC<IProps> = ({ content, setSelectedSrc }) => (
    <div className="carousel">
        <Slider {...carouselConfig}>
            {
                content.map((src, i) => (
                    <div key={i} className="carousel-item">
                        <Zoom onClick={() => setSelectedSrc(src)} />
                        <div key={i} className="main-page_carousel-img">
                            <img src={src} alt="" />
                        </div>
                    </div>
                ))
            }
        </Slider>
    </div>
);
